import { render, staticRenderFns } from "./taskItemList.vue?vue&type=template&id=40a9eaf6&"
import script from "./taskItemList.vue?vue&type=script&lang=js&"
export * from "./taskItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports